<div class="modal modal_size_744 modal__opened">
  <div class="modal__close icon icon-close" (click)="close()"></div>

  <ng-container *ngIf="!purchasing || melody.buyOnly; else loader">
    <ng-container *ngIf="isDataLoaded; else loadingData">
      <ng-container *ngIf="promo && privet; then subscriptionsSelectPrivetPromo else subscriptionsSelect">
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #loadingData>
  <div class="modal__container">
    <div class="modal__loader with-icon"></div>
  </div>
</ng-template>

<ng-template #subscriptionsSelectPrivetPromo>
  <ng-container>
    <div class="modal__container">
      <div class="modal__title modal__title-mb24 h2">{{ 'purchase-modal-with-promo.subscription-choose-title' | translate }}</div>
      <div class="modal__content">
        <div class="modal__plan">
          <div class="modal-plan">
            <div class="modal-plan__text">{{ 'purchase-modal-with-promo.without-privet-plus-text' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="purchaseMelody()">{{ 'purchase-modal.purchase' | translate }}</div>
      <div class="button button_type_light" (click)="close()">{{ 'logout-modal.cancel' | translate }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #subscriptionsSelect>
  <!--  <ng-container *ngIf="!privetPlusConfirmation else privetPlusBetter">-->
  <ng-container>
    <div class="modal__container">
      <div class="modal__title modal__title-mb24 h2">{{ 'purchase-modal.subscription-choose-title' | translate }}</div>
      <div class="modal__content">
        <div class="modal__plan" *ngIf="!melody.buyOnly">
          <div class="modal-plan modal-plan_type_recommended" [class.modal-plan_type_selected]="privetPlus || (!privet && !privetPlus && privetPlusPurchase)" (click)="togglePlan(true)">
            <div class="modal-plan__recommended" [innerHTML]="'purchase-modal.recommendation' | translate"></div>
            <div class="modal-plan__title" [innerHTML]="'purchase-modal.try-privet-plus-title' | translate"></div>
            <div class="modal-plan__text" [innerHTML]="'purchase-modal.try-privet-plus-text' | translate"></div>
            <div class="modal-plan__price" [innerHTML]="'purchase-modal.try-privet-plus-price' | translate"></div>
            <div class="modal-plan__price-hint" [innerHTML]="'purchase-modal.free-day' | translate"></div>
          </div>
        </div>
        <div class="modal__plan">
          <div class="modal-plan" [class.modal-plan_type_selected]="privet || (!privet && !privetPlus && !privetPlusPurchase)" (click)="togglePlan(false)">
            <div class="modal-plan__title" [innerHTML]="'purchase-modal.without-privet-plus-title' | translate"></div>
            <div class="modal-plan__text" [innerHTML]="'purchase-modal.without-privet-plus-text' | translate"></div>
            <div class="modal-plan__price" [innerHTML]="'purchase-modal.without-privet-plus-price' | translate: {price: melody.priceBuy, period: melody.period}"></div>
            <div class="modal-plan__price-hint" [innerHTML]="'purchase-modal.without-privet-plus-price-hint' | translate"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="purchaseMelody()">{{ 'purchase-modal.purchase' | translate }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #privetPlusBetter>
  <div class="modal__container">
    <div class="modal__img">
      <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
    </div>
    <div class="modal__title modal__title-mb12 h2">{{ 'purchase-modal.privet-plus-better-title' | translate }}</div>
    <div class="modal__text">{{ 'purchase-modal.privet-plus-better-text' | translate }}</div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button" (click)="purchaseMelodyWithPrivetPlus()">{{ 'purchase-modal.purchase-with-privet-plus' | translate }}</div>
    <div class="button button_type_light" (click)="purchaseMelodyWithPrivet()">{{ 'purchase-modal.purchase-without-privet-plus' | translate }}</div>
  </div>
</ng-template>

<ng-template #addingMelody>
  <ng-container *ngIf="!tooManyMelodiesError && !wrongServiceError else tooManyMelodies">
    <div class="modal__container">
      <div class="modal__img">
        <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
      </div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="privetPlusPurchase && !privetPlus">{{ 'purchase-modal.purchasing-melody-and-privet-plus' | translate }}</div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="!privetPlusPurchase && !privet">{{ 'purchase-modal.purchasing-melody-and-privet' | translate }}</div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="privet || privetPlus">{{ 'purchase-modal.purchasing-melody' | translate }}</div>
      <div class="modal__text">{{ 'purchase-modal.purchase-result-in-sms' | translate }}</div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="close()">{{ 'purchase-modal.ok-button' | translate }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #tooManyMelodies>
  <ng-container *ngIf="!wrongServiceError else wrongService">
  <div class="modal__img">
    <div class="modal-img modal-img_name_whistling modal-img_size_192"></div>
  </div>
  <div class="modal__title modal__title-mb12 h2">{{ 'purchase-modal.too-many-melodies-title' | translate }}</div>
  <div class="modal__text">{{ 'purchase-modal.too-many-melodies-text' | translate }}</div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button button_type_light" (click)="close()">{{ 'purchase-modal.ok-button' | translate }}</div>
  </div>
  </ng-container>
</ng-template>

<ng-template #wrongService>
  <div class="modal__img">
    <div class="modal-img modal-img_name_whistling modal-img_size_192"></div>
  </div>
  <div class="modal__title modal__title-mb12 h2">{{ 'purchase-modal.too-many-melodies-title' | translate }}</div>
  <div class="modal__text">{{ 'purchase-modal.corp-subscriber' | translate }}</div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button button_type_light" (click)="close()">{{ 'purchase-modal.ok-button' | translate }}</div>
  </div>
</ng-template>

<ng-template #loader>
  <ng-container *ngIf="requestInProgress else addingMelody">
    <div class="modal__container">
      <div class="modal__loader with-icon"></div>
    </div>
  </ng-container>
</ng-template>
